import { Block, Grid } from '@app/components/shared';
import { useAppDispatch } from '@app/redux/hooks';
import { setModalRegion, setCheckedRegion } from '@app/redux/slices/modalWindow';

import styles from './CheckedRegion.module.scss';

const CheckedRegion = () => {
  const dispatch = useAppDispatch();
  const PickClick = () => {
    dispatch(setModalRegion(true));
  };

  const clickVerification = () => {
    dispatch(setCheckedRegion(false));
  };

  return (
    <Block className={styles.CheckedRegion}>
      <span>Это ваш город?</span>
      <Grid className={styles.boxBtn} row>
        <div onClick={clickVerification} className={styles.Btn}>
          Да
        </div>
        <div onClick={PickClick} className={styles.Btn}>
          Выбрать другой
        </div>
      </Grid>
    </Block>
  );
};

export default CheckedRegion;
